import { render, staticRenderFns } from "./termsTrash.vue?vue&type=template&id=57bc7592&scoped=true&"
import script from "./termsTrash.vue?vue&type=script&lang=js&"
export * from "./termsTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc7592",
  null
  
)

export default component.exports